import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
    effect
} from '@angular/core';
import { CasdoorAuthService } from 'app/core/auth/casdoor-auth.service';
import { Constants } from '../../../../utils/constants';
import { User } from '../../../core/user/user.model';
import { UserService } from '../../../core/user/user.service';

@Component({
    selector: 'refresh-token',
    templateUrl: './refresh-token.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefreshTokenComponent {

    // Service signals
    user = this._userService.user;

    constructor(
        private auth: CasdoorAuthService,
        private _userService: UserService,
    ) {
        // Effect to handle user changes and share with plugin
        effect(() => {
            const user = this.user();
            if (user) {
                this.shareUserWithPlugin(user);
            }
        });
    }

    shareUserWithPlugin(user: User) {
        this.auth.getAccessTokenSilently({ cacheMode: 'off' }).subscribe((token) => {
            const userData = {
                name: user.name ?? "",
                email: user.email,
                token : token,
            };
            console.log("User Data::: ", userData);
            localStorage.setItem(
                Constants.storageKeys.authUser,
                JSON.stringify(userData)
            );
        });
    }
}